import React from 'react';
import '../css/CursoLs.css';
import Footer from '../components/Footer';
import Section1 from '../components/Section1';
import Section2 from '../components/Section2';
import Section3 from '../components/Section3';
import SectionButton from '../components/SectionButton';
import SectionFaq from '../components/SectionFaq';
import SectionLine from '../components/SectionLine';
import SectionPrice from '../components/SectionPrice';
import WhatsAppButton from '../components/WhatsAppButton';
import faqData from '../data/faqData';
import Certificate from '../components/Certificate';
import CallOnWhats from '../components/CallOnWhats';
import CourseContent from '../components/CourseContent';
import contData from '../data/contData';
import Benefits from '../components/Benefits';

function CursoLsV2() {
    const url = "https://pay.hotmart.com/A89223462B?off=rsf3fysj"
    return (
        <div>
            <Section1 link={url} />
            <Section2 link={url} />
            <Benefits />
            <SectionPrice instalment={"9,98"} price={"49,90"} number={"5"} link={url} />
            <Section3 />
            <SectionButton link={url} />
            <SectionLine />
            <CourseContent data={contData} link={url} />
            <Certificate />
            <SectionFaq data={faqData} />
            <CallOnWhats phoneNumber="5521964850880" message="Estou com dúvida sobre o curso, pode me ajudar?" />
            <WhatsAppButton phoneNumber="5521964850880" message="Estou com dúvida sobre o curso, pode me ajudar?" />
            <Footer />
        </div>
    );
}

export default CursoLsV2;
